module.exports = __webpack_public_path__ + "img/check.ca34d68d.svg";